/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import summaryService from './summaryService'

export const summaryMapLayers = [
  'land',
  'authorizedLimit',
  'restrictions',
  'buildings',
]

const initialState = {
  loading: true,
  error: false,
  loadEstimation: false,
  buildingValue: {},
  estimate: {},
  selectedLayers: summaryMapLayers,
  cityGeoCenter: {},
  cityGeojson: {},
  user: {},
  company: {},
  theme: {
    primary: null as string | null,
    secondary: null as string | null,
  },
  transactionDetail: {},
  office: {},
  creationDate: null,
}

export const getBuildingSummary = createAsyncThunk(
  'summary/getBuildingSummary',
  summaryService.getBuildingSummary,
)

const buildingSummary = createSlice({
  name: 'buildingSummary',
  initialState,
  reducers: {
    updateTheme(state, action) {
      if (action.payload.primary || action.payload.secondary) {
        state.theme = {
          primary: action.payload.primary ? `#${action.payload.primary}` : null,
          secondary: action.payload.secondary
            ? `#${action.payload.secondary}`
            : null,
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBuildingSummary.pending, (state) => {
        state.loading = true
        state.error = false
      })
      .addCase(getBuildingSummary.fulfilled, (state, action) => {
        const { data } = action.payload || {}

        if (action?.payload?.errors?.length > 0) {
          state.loading = false
          state.error = true
          window.location.href = '/link-expired'

          return
        }

        state.buildingValue = action.payload
        state.creationDate = action.payload.data.update_timestamp
        state.company = data?.company
        state.office = data?.office
        state.loading = false
        state.error = false
        state.estimate = data?.value
      })
      .addCase(getBuildingSummary.rejected, (state) => {
        state.loading = false
        state.error = true
        window.location.href = '/link-expired'
      })
  },
})

export const buildingSummaryReducer = {
  buildingSummary: buildingSummary.reducer,
}

export const { updateTheme } = buildingSummary.actions
